import { memo } from 'react';

import { BaseAttachmentDto } from '@eva/types/dto';
import PopperTooltip from 'shared/ui/Popper/PopperTooltip';

export interface FileButtonDownloadProps<F extends BaseAttachmentDto> {
  file: F;
  onObtainUrl: (file: Partial<F>) => Promise<string>;
}

const style = { fontSize: '14px' };

const FileButtonDownload = <F extends BaseAttachmentDto>({ file, onObtainUrl }: FileButtonDownloadProps<F>) => (
  <>
    <PopperTooltip placement="top" overlay={translate('Download')}>
      <button
        type="button"
        className="btn btn-xs btn-tool-box no-padding margin-right margin-left"
        style={style}
        onClick={(event) => {
          event.preventDefault();
          onObtainUrl(file).then((url) => {
            const link = document.createElement('a');
            link.setAttribute('href', url);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        }}
      >
        <i className="lnr lnr-download" />
      </button>
    </PopperTooltip>
  </>
);

// eslint-disable-next-line import/no-default-export
export default memo(FileButtonDownload);
